import { format } from 'date-fns';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useLanguage } from '@/contexts/LanguageContext';
import type { DemographicsDraft, Gender } from '@/lib/firebase/queries/patientDemographics';


interface DemographicsInputsProps {
  value: DemographicsDraft;
  onChange: (value: DemographicsDraft) => void;
  disabled?: boolean;
}

/** Optional gender + date of birth, as asked at sign-up. */
export function DemographicsInputs({ value, onChange, disabled }: DemographicsInputsProps) {
  const { t } = useLanguage();
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="space-y-1">
        <Label className="text-sm">{t('auth.gender')} <span className="text-muted-foreground">({t('auth.optional')})</span></Label>
        <Select value={value.gender} onValueChange={(g) => onChange({ ...value, gender: g as Gender })} disabled={disabled}>
          <SelectTrigger>
            <SelectValue placeholder={t('auth.chooseGender')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="male">{t('auth.male')}</SelectItem>
            <SelectItem value="female">{t('auth.female')}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <Label className="text-sm">{t('auth.dateOfBirth')} <span className="text-muted-foreground">({t('auth.optional')})</span></Label>
        <Input type="date" dir="ltr" value={value.dateOfBirth} max={format(new Date(), 'yyyy-MM-dd')} disabled={disabled}
          onChange={(e) => onChange({ ...value, dateOfBirth: e.target.value })} />
      </div>
    </div>
  );
}
